var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-list',{attrs:{"resource":"commandRuns","filters":_vm.filters,"filter":{
    _id: _vm.item ? _vm.item.id : ''
  },"sort-by":['created_at'],"sort-desc":['true'],"disable-global-search":"","disable-export":"","disable-create":""}},[_c('va-data-table',{attrs:{"fields":_vm.fields,"disable-edit":"","disable-clone":"","disable-delete":"","disable-select":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }